import { Controller } from 'stimulus'
import './component.scss'

class CompanyTabbarTabletController extends Controller {
  scrollToStaff(event) {
    const target = document.getElementById('company-show-staff-tablet')
    if (target) {
      event.preventDefault()
      target.scrollIntoView({ behavior: 'smooth' })
    }
  }
}

window.Stimulus.register('company-tabbar-tablet', CompanyTabbarTabletController)
